import React from "react";
import styles from "./Copyright.module.scss";

const date = new Date();
const currentYear = date.getFullYear();

const copyrightData = [
    `© «Европейская Юридическая Служба», 2007— ${currentYear}`,
    "Круглосуточная поддержка экспертов. Все права защищены.",
];

const Copyright: React.FC = () => {
    return (
        <div className={styles.copyright}>
            {copyrightData.map((copyright, idx) =>
                <div className={styles.copyrightItem} key={idx}>{copyright}</div>
            )}
        </div>
    );
}

export default Copyright;
